import React, { useEffect, useState } from 'react';
import { Col, Divider, Input, Modal, Row, Select, Typography, Button } from 'antd';
import { FilterFilled } from '@ant-design/icons';
import PhoneInput from 'react-phone-input-2';
import { useAuthContext } from 'contexts/Auth';
import { useDataContext } from '../../../contexts/Data';

import genders from 'data/genders.json'

const { Text } = Typography;
const { Option } = Select;

export default function FilteredModal({ open, filtered, setFiltered, handleFilterApplications, handleClose }) {

    const { cnic, sortOrder, registrationNumber, fullName, email, phone, courseId, learningType, session, payment, batch, result, gender } = filtered;

    const { isSuperAdminOrOwner } = useAuthContext();
    const { courses } = useDataContext()

    const [sessions, setSessions] = useState([])

    useEffect(() => {
        if (courses.length > 0) {
            const sessionArray = [...new Set(courses.flatMap(item => [...item.classSessionsForMales, ...item.classSessionsForFemales]).map(session => session.time))].sort();
            setSessions(sessionArray)
        }
    }, [courses])

    return (
        <Modal open={open} onCancel={handleClose} onClose={handleClose} centered footer={false} className='filter-modal' width={850}>
            <Text strong>Filter Applications</Text>
            <Divider className='my-2' />

            <Row gutter={[12, 12]}>
                <Col xs={24} sm={isSuperAdminOrOwner ? 12 : 24}><Input placeholder="Full Name" value={fullName} onChange={(e) => setFiltered((s) => ({ ...s, fullName: e.target.value }))} /></Col>
                <Col xs={24} sm={12}><Input placeholder="CNIC" maxLength={13} onKeyPress={window.onlyNumber} value={cnic} onChange={(e) => setFiltered((s) => ({ ...s, cnic: e.target.value }))} /></Col>
                <Col xs={24} sm={12}><Input placeholder="Email" type="email" value={email} onChange={(e) => setFiltered((s) => ({ ...s, email: e.target.value }))} /></Col>
                <Col xs={24} sm={12}><Input placeholder="Register Number (PTP-01-000005)" value={registrationNumber} onChange={(e) => setFiltered((s) => ({ ...s, registrationNumber: e.target.value }))} /></Col>
                <Col xs={24} sm={12}><PhoneInput country={'pk'} value={phone} inputStyle={{ width: '100%' }} onChange={(value) => setFiltered((s) => ({ ...s, phone: value }))} /></Col>
                <Col xs={24} sm={12}>
                    <Select showSearch allowClear placeholder="Select course" className="w-100" value={courseId}
                        filterOption={(input, option) => (option?.children ?? '').toLowerCase().includes(input.toLowerCase())} onChange={(value) => setFiltered((s) => ({ ...s, courseId: value }))}>
                        {courses.map((course) => (<Option key={course.id} value={course.id}>{course.title}</Option>))}
                    </Select>
                </Col>
                <Col xs={24} sm={12} md={6}><Input showSearch onKeyPress={window.onlyNumber} placeholder="Batch" className="w-100" value={batch} onChange={(e) => setFiltered((s) => ({ ...s, batch: e.target.value }))}></Input></Col>
                <Col xs={24} sm={12} md={6} ><Select showSearch allowClear placeholder="Select learning type" options={[{ label: "Onsite", value: "onsite" }, { label: "Online", value: "online" }]} className="w-100" value={learningType} onChange={(value) => setFiltered((s) => ({ ...s, learningType: value }))}></Select></Col>
                <Col xs={24} sm={12}>
                    <Select showSearch allowClear placeholder="Select session" className="w-100" value={session} onChange={(value) => setFiltered((s) => ({ ...s, session: value }))}>
                        {sessions.map((session) => (<Option key={session} value={session}>{session}</Option>))}
                    </Select>
                </Col>
                <Col xs={24} sm={12} md={6}><Select showSearch allowClear placeholder="Select payment" options={[{ label: "Pending", value: "pending" }, { label: "Received", value: "received" }]} className="w-100" value={payment} onChange={(value) => setFiltered((s) => ({ ...s, payment: value }))}></Select></Col>
                <Col xs={24} sm={12} md={6}><Select showSearch allowClear placeholder="Select result" options={[{ label: "Pending", value: "pending" }, { label: "Passed", value: "passed" }, { label: "Failed", value: "failed" }]} className="w-100" value={result} onChange={(value) => setFiltered((s) => ({ ...s, result: value }))}></Select></Col>
                <Col xs={24} sm={12}>
                    <Select showSearch className="w-100" placeholder="Select a gender" onChange={(value) => setFiltered((s) => ({ ...s, gender: value }))}
                        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                        options={genders}
                        value={gender}
                    />
                </Col>
                <Col xs={24} sm={12} md={12}><Select placeholder="Sort Order" className="w-100" value={sortOrder} defaultValue={sortOrder} onChange={(value) => setFiltered((s) => ({ ...s, sortOrder: value }))}
                    options={[{ label: "Latest", value: 'latest' }, { label: "Oldest", value: 'oldest' }, { label: "A - Z", value: 'a-z' }, { label: "Z - A", value: 'z-a' },]} />
                </Col>

                <Col xs={24} className="d-flex justify-content-end"><Button type="primary" className="w-25" icon={<FilterFilled />} onClick={handleFilterApplications}>Filter</Button></Col>
            </Row>
        </Modal >
    );
}
